import { Dialog } from '@mui/material';
import React from 'react';
import { ReactComponent as Info } from "../../../../../../../assets/img/svg/InfoCircle.svg"
import { ReactComponent as CrossIcon } from "../../../../../../../assets/img/svg/CrossIcon.svg"
import AButton from '../../../../common/form-fields-mui/AButton';
import styles from "../styles.module.scss"

const ReceiptCreationInProcessDialog = ({ open, closeHandler, mobNo, emailId }) => {

    return (

        <Dialog open={open}>

            <div className={styles['dialog-padding']}>

                <div className='d-flex justify-content-between'>

                    <Info className={styles['dialog-done-icon']}/>
                    <CrossIcon onClick={closeHandler} className={styles['dialog-cross-icon']} />

                </div>

                <div className={`mt-2 ${styles['verify-details-dialog-header']}`}>
                    Receipt generation is in process
                </div>

                <div className={` my-2 ${styles['cancel-collection-dialog-sub-header']}`}>
                Once the receipt is generated, it will be automatically sent on student’s registered mobile number {mobNo} and email id {emailId}.
                </div>

                    <AButton
                        variant='primary_filled'
                        className='no-ml-btn'
                        onClick={closeHandler}
                    >
                        Okay
                    </AButton>


            </div>
        </Dialog>
    );
}

export default ReceiptCreationInProcessDialog;